import { render, staticRenderFns } from "./afterDetail.vue?vue&type=template&id=35f2beb7&scoped=true"
import script from "./afterDetail.vue?vue&type=script&lang=js"
export * from "./afterDetail.vue?vue&type=script&lang=js"
import style0 from "./afterDetail.vue?vue&type=style&index=0&id=35f2beb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f2beb7",
  null
  
)

export default component.exports